import FingerprintJS from "@fingerprintjs/fingerprintjs";

export const sessionId = async () => {
	// Initialize an agent at application startup.
	const fpPromise = FingerprintJS.load();

	// Get the visitor identifier when you need it.
	const fp = await fpPromise;
	const result = await fp.get();

	// This is the visitor identifier:
	const visitorId = result.visitorId;
	return visitorId;
};

export const getSessionId = async (officeSlug) => {
	const sessionID = await sessionId();
	const sessionIdForTesting =
		officeSlug === "zero-q-demo" ||
		officeSlug === "qa-informatica-1" ||
		officeSlug === "zeroq-qa-fisico" ||
		officeSlug === "demo-web-frontend";
	const max = 100000000;
	const randomNumber = Math.floor(Math.random() * max) + 1;
	const res = await sessionID;
	const fixedSessionId = sessionIdForTesting ? randomNumber : res;
	return fixedSessionId;
};
